var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{staticClass:"p-4 p-md-5 m-0 shadow rounded-lg"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }